import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/uxp-photoshop/uxp-photoshop/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const InlineAlert = makeShortcode("InlineAlert");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "packaging-your-plugin"
    }}>{`Packaging Your Plugin`}</h1>
    <p>{`Taking your plugin code and packaging it has never been easier.`}</p>
    <p>{`UXP plugins for Photoshop are distributed in the form of a `}<inlineCode parentName="p">{`.ccx`}</inlineCode>{` file. Under the hood, this is a zip file. Unless you have some special requirements, you should not be creating this zip file yourself.`}</p>
    <InlineAlert variant="info" slots="text" mdxType="InlineAlert" />
    <p><strong parentName="p">{`IMPORTANT`}</strong>{`:
Before you package your plugin for distribution outside your own computer, make sure you've obtained a valid ID from the `}<a parentName="p" {...{
        "href": "https://console.adobe.io"
      }}>{`Adobe Developer Console`}</a>{`. Without an id (which goes in the `}<inlineCode parentName="p">{`id`}</inlineCode>{` field of your plugin's `}<inlineCode parentName="p">{`manifest.json`}</inlineCode>{` file), you won't be able to distribute your plugin in the Creative Cloud Marketplace.`}</p>
    <p>{`Using the `}<a parentName="p" {...{
        "href": "../../devtool/"
      }}>{`UXP Developer Tool`}</a>{`, choose `}<inlineCode parentName="p">{`Package`}</inlineCode>{` from the Actions menu (the ellipsis on the right side of the Developer Tool window, on the same line as your plugin name):`}</p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "280px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "240%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "display": "block",
            "transition": "opacity 0.5s 0.5s",
            "pointerEvents": "none"
          }
        }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
            "srcSet": ["/photoshop/uxp/static/15139edff2136f8ebc716710fc7f54fc/f0258/udt-package-menu.webp 280w"],
            "sizes": "(max-width: 280px) 100vw, 280px",
            "type": "image/webp"
          }}></source>{`
          `}<source parentName="picture" {...{
            "srcSet": ["/photoshop/uxp/static/15139edff2136f8ebc716710fc7f54fc/908b1/udt-package-menu.png 280w"],
            "sizes": "(max-width: 280px) 100vw, 280px",
            "type": "image/png"
          }}></source>{`
          `}<img parentName="picture" {...{
            "className": "gatsby-resp-image-image",
            "src": "/photoshop/uxp/static/15139edff2136f8ebc716710fc7f54fc/908b1/udt-package-menu.png",
            "alt": "Package Menu",
            "title": "Package Menu",
            "loading": "lazy",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "opacity": "0",
              "transition": "opacity 0.5s",
              "color": "inherit",
              "boxShadow": "inset 0px 0px 0px 400px none",
              "top": "0",
              "left": "0"
            }
          }}></img>{`
        `}</picture>{`
    `}</span></p>
    <p>{`This shows a "Select target directory" dialog. Choose a directory where your built plugin `}<inlineCode parentName="p">{`.ccx`}</inlineCode>{` file should reside.`}</p>
    <p>{`After the `}<inlineCode parentName="p">{`.ccx`}</inlineCode>{` file has been created, you should see this message at the bottom of the Developer Tool window:`}</p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "788px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "14.375000000000002%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "display": "block",
            "transition": "opacity 0.5s 0.5s",
            "pointerEvents": "none"
          }
        }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
            "srcSet": ["/photoshop/uxp/static/f1bdd32ca30c6a49ec9754b201dea5a6/cb523/package-success.webp 320w", "/photoshop/uxp/static/f1bdd32ca30c6a49ec9754b201dea5a6/797b9/package-success.webp 640w", "/photoshop/uxp/static/f1bdd32ca30c6a49ec9754b201dea5a6/2b36d/package-success.webp 788w"],
            "sizes": "(max-width: 788px) 100vw, 788px",
            "type": "image/webp"
          }}></source>{`
          `}<source parentName="picture" {...{
            "srcSet": ["/photoshop/uxp/static/f1bdd32ca30c6a49ec9754b201dea5a6/72799/package-success.png 320w", "/photoshop/uxp/static/f1bdd32ca30c6a49ec9754b201dea5a6/6af66/package-success.png 640w", "/photoshop/uxp/static/f1bdd32ca30c6a49ec9754b201dea5a6/ea7fb/package-success.png 788w"],
            "sizes": "(max-width: 788px) 100vw, 788px",
            "type": "image/png"
          }}></source>{`
          `}<img parentName="picture" {...{
            "className": "gatsby-resp-image-image",
            "src": "/photoshop/uxp/static/f1bdd32ca30c6a49ec9754b201dea5a6/ea7fb/package-success.png",
            "alt": "Package Success",
            "title": "Package Success",
            "loading": "lazy",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "opacity": "0",
              "transition": "opacity 0.5s",
              "color": "inherit",
              "boxShadow": "inset 0px 0px 0px 400px none",
              "top": "0",
              "left": "0"
            }
          }}></img>{`
        `}</picture>{`
    `}</span></p>
    <p>{`If instead, you see this:`}</p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "660px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "15%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "display": "block",
            "transition": "opacity 0.5s 0.5s",
            "pointerEvents": "none"
          }
        }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
            "srcSet": ["/photoshop/uxp/static/ae9f0d6fdff6a0eec3482a2cf2a550e5/cb523/package-failed.webp 320w", "/photoshop/uxp/static/ae9f0d6fdff6a0eec3482a2cf2a550e5/797b9/package-failed.webp 640w", "/photoshop/uxp/static/ae9f0d6fdff6a0eec3482a2cf2a550e5/54c64/package-failed.webp 660w"],
            "sizes": "(max-width: 660px) 100vw, 660px",
            "type": "image/webp"
          }}></source>{`
          `}<source parentName="picture" {...{
            "srcSet": ["/photoshop/uxp/static/ae9f0d6fdff6a0eec3482a2cf2a550e5/72799/package-failed.png 320w", "/photoshop/uxp/static/ae9f0d6fdff6a0eec3482a2cf2a550e5/6af66/package-failed.png 640w", "/photoshop/uxp/static/ae9f0d6fdff6a0eec3482a2cf2a550e5/1f083/package-failed.png 660w"],
            "sizes": "(max-width: 660px) 100vw, 660px",
            "type": "image/png"
          }}></source>{`
          `}<img parentName="picture" {...{
            "className": "gatsby-resp-image-image",
            "src": "/photoshop/uxp/static/ae9f0d6fdff6a0eec3482a2cf2a550e5/1f083/package-failed.png",
            "alt": "Package Failed",
            "title": "Package Failed",
            "loading": "lazy",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "opacity": "0",
              "transition": "opacity 0.5s",
              "color": "inherit",
              "boxShadow": "inset 0px 0px 0px 400px none",
              "top": "0",
              "left": "0"
            }
          }}></img>{`
        `}</picture>{`
    `}</span></p>
    <p>{`Click on `}<inlineCode parentName="p">{`Details`}</inlineCode>{` to view a window that shows why the packaging failed.`}</p>
    <p>{`Once your `}<inlineCode parentName="p">{`.ccx`}</inlineCode>{` file has been built, you should test it locally before doing anything else. To install a .ccx file into any Creative Cloud application, double click it. This will open the Creative Cloud application, and you'll get a warning that your plugin hasn't been verified by Adobe:`}</p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "868px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "52.81250000000001%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "display": "block",
            "transition": "opacity 0.5s 0.5s",
            "pointerEvents": "none"
          }
        }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
            "srcSet": ["/photoshop/uxp/static/34e794f7595a5a11641c2c56ffc5077d/cb523/verify-failed.webp 320w", "/photoshop/uxp/static/34e794f7595a5a11641c2c56ffc5077d/797b9/verify-failed.webp 640w", "/photoshop/uxp/static/34e794f7595a5a11641c2c56ffc5077d/26f05/verify-failed.webp 868w"],
            "sizes": "(max-width: 868px) 100vw, 868px",
            "type": "image/webp"
          }}></source>{`
          `}<source parentName="picture" {...{
            "srcSet": ["/photoshop/uxp/static/34e794f7595a5a11641c2c56ffc5077d/72799/verify-failed.png 320w", "/photoshop/uxp/static/34e794f7595a5a11641c2c56ffc5077d/6af66/verify-failed.png 640w", "/photoshop/uxp/static/34e794f7595a5a11641c2c56ffc5077d/748b0/verify-failed.png 868w"],
            "sizes": "(max-width: 868px) 100vw, 868px",
            "type": "image/png"
          }}></source>{`
          `}<img parentName="picture" {...{
            "className": "gatsby-resp-image-image",
            "src": "/photoshop/uxp/static/34e794f7595a5a11641c2c56ffc5077d/748b0/verify-failed.png",
            "alt": "Verify Failed",
            "title": "Verify Failed",
            "loading": "lazy",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "opacity": "0",
              "transition": "opacity 0.5s",
              "color": "inherit",
              "boxShadow": "inset 0px 0px 0px 400px none",
              "top": "0",
              "left": "0"
            }
          }}></img>{`
        `}</picture>{`
    `}</span></p>
    <p>{`Since you wrote the plugin, it's probably safe to install. Click `}<inlineCode parentName="p">{`Install locally`}</inlineCode>{` and you'll see another warning:`}</p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "1280px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "50.31250000000001%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "display": "block",
            "transition": "opacity 0.5s 0.5s",
            "pointerEvents": "none"
          }
        }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
            "srcSet": ["/photoshop/uxp/static/9f2b1998096aac9e60a920bea16d1e51/cb523/install-warning.webp 320w", "/photoshop/uxp/static/9f2b1998096aac9e60a920bea16d1e51/797b9/install-warning.webp 640w", "/photoshop/uxp/static/9f2b1998096aac9e60a920bea16d1e51/4b075/install-warning.webp 1280w", "/photoshop/uxp/static/9f2b1998096aac9e60a920bea16d1e51/ed4c1/install-warning.webp 1368w"],
            "sizes": "(max-width: 1280px) 100vw, 1280px",
            "type": "image/webp"
          }}></source>{`
          `}<source parentName="picture" {...{
            "srcSet": ["/photoshop/uxp/static/9f2b1998096aac9e60a920bea16d1e51/72799/install-warning.png 320w", "/photoshop/uxp/static/9f2b1998096aac9e60a920bea16d1e51/6af66/install-warning.png 640w", "/photoshop/uxp/static/9f2b1998096aac9e60a920bea16d1e51/21b4d/install-warning.png 1280w", "/photoshop/uxp/static/9f2b1998096aac9e60a920bea16d1e51/8b936/install-warning.png 1368w"],
            "sizes": "(max-width: 1280px) 100vw, 1280px",
            "type": "image/png"
          }}></source>{`
          `}<img parentName="picture" {...{
            "className": "gatsby-resp-image-image",
            "src": "/photoshop/uxp/static/9f2b1998096aac9e60a920bea16d1e51/21b4d/install-warning.png",
            "alt": "Install Warning",
            "title": "Install Warning",
            "loading": "lazy",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "opacity": "0",
              "transition": "opacity 0.5s",
              "color": "inherit",
              "boxShadow": "inset 0px 0px 0px 400px none",
              "top": "0",
              "left": "0"
            }
          }}></img>{`
        `}</picture>{`
    `}</span></p>
    <p>{`Since, in this case, `}<em parentName="p">{`you`}</em>{` are the third-party developer, it's safe to click OK. Obviously, if someone else sends you a `}<inlineCode parentName="p">{`.ccx`}</inlineCode>{` file and you get this dialog, you should make sure you trust the person who sent it.`}</p>
    <p>{`Now that you have your plugin installed, test it again to make sure the packaged version performs correctly. Then move on to `}<a parentName="p" {...{
        "href": "../distribution-options"
      }}>{`Options for Distribution`}</a>{` to get your plugin out into the world.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      